import {
	collection,
	getDocs
} from "firebase/firestore";

import { db }
from "../firebase/firebaseConfig";

const calcularEnergia = (
	progreso
) => {

	if (
		!progreso?.ultimaEvaluacion
	) {
		return 0;
	}

	const fecha =
		progreso
			.ultimaEvaluacion
			.toDate
			? progreso.ultimaEvaluacion.toDate()
			: new Date(
				progreso.ultimaEvaluacion
			);

	const dias =
		Math.floor(
			(
				new Date() -
				fecha
			)
			/
			(1000 * 60 * 60 * 24)
		);

	return Math.max(
		0,
		100 - dias * 3
	);
};

const calcularEstadoTema = (
	progreso
) => {

	if (!progreso) {

		return "sin_datos";
	}


	const total =
		progreso.totalRespondidas || 0;


	if (total === 0) {

		return "sin_datos";
	}


	let dominio =
		progreso.dominioActual;


	if (
		dominio === undefined ||
		dominio === null
	) {

		dominio =
			Math.round(
				(
					(progreso.correctas || 0)
					/
					total
				) * 100
			);
	}


	let diasSinRepasar = 0;


	if (
		progreso.ultimaEvaluacion
	) {

		diasSinRepasar =
			Math.floor(
				(
					Date.now() -
					progreso
						.ultimaEvaluacion
						.toDate()
						.getTime()
				)
				/
				(1000 * 60 * 60 * 24)
			);
	}


	const desgaste =
		Math.floor(
			diasSinRepasar / 7
		) * 5;


	const dominioReal =
		Math.max(
			0,
			dominio - desgaste
		);


	if (total < 5) {

		return "explorando";
	}


	if (dominioReal >= 85) {

		return "dominado";
	}


	if (dominioReal >= 70) {

		return "estable";
	}


	if (dominioReal >= 50) {

		return "repasar";
	}


	return "critico";
};

const calcularEstadoMemoria = (
	progreso
) => {

	if (
		!progreso?.ultimaEvaluacion
	) {
		return "olvidado";
	}

	const dias =
		(
			Date.now()
			-
			progreso
				.ultimaEvaluacion
				.toDate()
				.getTime()
		)
		/
		1000
		/
		60
		/
		60
		/
		24;

	if (dias <= 7)
		return "fresco";

	if (dias <= 30)
		return "estable";

	if (dias <= 60)
		return "enfriandose";

	return "olvidado";
};

const calcularMapaComponente =
async (
	userId,
	componenteId
) => {

	const [
		temasSnap,
		temaCompSnap,
		progresoSnap
	] = await Promise.all([

		getDocs(
			collection(
				db,
				"materias_temas"
			)
		),

		getDocs(
			collection(
				db,
				"tema_componente"
			)
		),

		getDocs(
			collection(
				db,
				"progreso_temas"
			)
		)
	]);

	const temas =
		temasSnap.docs.map(
			d => d.data()
		);

	const relaciones =
		temaCompSnap.docs.map(
			d => d.data()
		);

		const relacionesPorTema = {};

		relaciones.forEach(rel => {
		
			relacionesPorTema[
				Number(rel.TemaID)
			] = rel;
		
		});	

	const progresos =
		progresoSnap.docs
			.map(d => d.data())
			.filter(
				d =>
				d.userId === userId
			);

	const temasDelComponente =
		relaciones
			.filter(
				r =>
				r.Componentes?.includes(
					Number(
						componenteId
					)
				)
			)
			.map(
				r => r.TemaID
			);

	const resultado =
		temas
			.filter(
				t =>
				temasDelComponente.includes(
					Number(t.ID)
				)
			)
			.map(tema => {

				const progreso =
    progresos.find(

        p =>

        Number(
            p.temaId
        ) ===
        Number(
            tema.ID
        )

    );

const configuracion =

    relacionesPorTema[
        Number(tema.ID)
    ];
	return {

		id: tema.ID,
	
		nombre: tema.Tema,
	
		energia:
			calcularEnergia(
				progreso
			),
	
		prerrequisitos:
			tema.Prerrequisitos || [],
	
		estado:
			calcularEstadoTema(
				progreso
			),
	
		memoria:
			calcularEstadoMemoria(
				progreso
			),
	
		nivel: 0,
	
		peso:
	
			Number(
				configuracion?.Peso ?? 1
			),
	
		nivelObjetivo:
	
			Number(
				configuracion?.NivelObjetivo ?? 3
			),
	
		tiempoEsperado:
	
			Number(
				configuracion?.TiempoEsperado ?? 90
			),
	
		importancia:
	
			Number(
				configuracion?.ImportanciaPedagogica ?? 3
			),
	
		pesoHistorico:
	
			Number(
				configuracion?.PesoHistorico ?? 1
			),
	
		activo:
	
			Number(
				configuracion?.Activo ?? 1
			)
	
	};
					
			});

	// aplicar bloqueos

	resultado.forEach(
		tema => {

			if (
				!tema.prerrequisitos
					.length
			) {
				return;
			}

			const desbloqueado =
				tema.prerrequisitos
					.every(
						preId => {

							const pre =
								resultado.find(
									t =>
									Number(t.id) ===
									Number(preId)
								);

								return (
									pre &&
									pre.estado !==
									"sin_datos"
								);
						}
					);

			if (
				!desbloqueado
			) {

				tema.estado =
					"bloqueado";
			}
		}
	);

	const calcularNivel = (
		tema,
		mapa,
		cache = {}
	) => {
	
		if (
			cache[tema.id] !==
			undefined
		) {
			return cache[tema.id];
		}
	
		if (
			!tema.prerrequisitos?.length
		) {
	
			cache[tema.id] = 0;
	
			return 0;
		}
	
		const nivel =
			1 +
			Math.max(
				...tema.prerrequisitos.map(
					preId => {
	
						const pre =
							mapa.find(
								t =>
								Number(
									t.id
								) ===
								Number(
									preId
								)
							);
	
						if (!pre) {
							return 0;
						}
	
						return calcularNivel(
							pre,
							mapa,
							cache
						);
					}
				)
			);
	
		cache[tema.id] =
			nivel;
	
		return nivel;
	};
	
	resultado.forEach(
		tema => {
	
			tema.nivel =
				calcularNivel(
					tema,
					resultado
				);
		}
	);

	return resultado;
};

export default
	calcularMapaComponente;